import { render, staticRenderFns } from "./ExpertDetails.vue?vue&type=template&id=05771b4b&scoped=true&"
import script from "./ExpertDetails.vue?vue&type=script&lang=js&"
export * from "./ExpertDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpertDetails.vue?vue&type=style&index=0&id=05771b4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05771b4b",
  null
  
)

export default component.exports